export const headerDefaults = {
  // zakynthos
  DEFAULT_SELECTED_DESTINATION: 290,
};
